import { DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useAgencyPublications from '@hooks/useAgencyPublications'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import AgencyPublicationListItem from './AgencyPublicationListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'agency_string',
      label: 'Agency Title or ID',
    },
  ]
}

interface AgenciesProps {
  publicationId: number,
}

const Agencies = (props: AgenciesProps) => {
  const { publicationId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const agencyPublicationPayload = useAgencyPublications({
    filters: {
      ...pageFilters,
      publication_id: publicationId,
    },
    performHttpRequests: !!publicationId,
    requestOptions: {
      include_agency_publication_agency: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    // @ts-expect-error TS2339
    filteredAgencyPublicationCount,
    filteredAgencyPublications,
    hasFilteredAgencyPublications,
    loading,
  } = agencyPublicationPayload

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-agencies' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Agencies"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && hasFilteredAgencyPublications && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection maxHeight={600}>
          {filteredAgencyPublications.map(agencyPublication => (
            <AgencyPublicationListItem
              key={agencyPublication.id}
              agencyPublication={agencyPublication}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasFilteredAgencyPublications && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Agencies Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please add an agency below
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredAgencyPublicationCount}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default Agencies
